// extracted by mini-css-extract-plugin
export default {"description":"_1GjIoCfc0JTv0u23TuUn-p"};